import { HttpClient, Headers } from '@wix/http-client';
import { WIX_META_SITE_ID_HEADER } from 'config/consts';
import { useAppStore } from 'stores/state';

const baseURL = window.location.origin + window.__BASEURL__;

const client = new HttpClient({ baseURL });

const ambassador = new HttpClient({
  createHeaders: () => {
    const { metaSiteId } = useAppStore.getState();
    return { [WIX_META_SITE_ID_HEADER]: metaSiteId } as Headers;
  },
});

export const httpUtils = {
  client,
  ambassador,
};
